import { COMPLETED, UPCOMING } from 'constants/GameStatuses';
import NavBar from '../NavBar';
import NavButton from '../NavButton';
import setUtmReferrer from 'helpers/setUtmReferrer';
import styles from './styles/GameSubNav.module.scss';
import PageSection from '../PageSection';
import { Fragment } from 'react';
import cn from 'classnames';
import { GameTeamResultEnum } from 'queries';
import TeamImage from 'components/TeamImage';
import LocalizedDate from 'components/LocalizedDate';
import Link from 'components/Link';

export default function GameSubNav({
  game
}: {
  game: {
    clockText?: string;
    contest?: {
      bracket?: {
        webPath: string;
      };
      hometownTicketingUrl?: string;
      gofanTicketingUrl?: string;
      nfhsNetworkUrl?: string;
      contestParticipants?: {
        id: string;
        votes?: number;
        participant: {
          __typename: string;
          id?: string;
        };
      }[];
    };
    date: string;
    gameTeams: {
      id: string;
      isHome: boolean;
      isTbd: boolean;
      result?: GameTeamResultEnum;
      scoreText?: string;
      standing: { overallRecord: string };
      team: {
        abbrev: string;
        name: string;
        mascot?: string;
        image?: string;
        webPath: string;
      };
    }[];
    mediumStatusText: string;
    statusId: number;
    webPath: string;
    webBoxscorePath?: string;
    webScorebookCastPath?: string;
    webRecapPath?: string;
    webPhotosPath?: string;
    webPreviewPath?: string;
  };
}) {
  return (
    <>
      <div className={styles.Header}>
        <PageSection className={styles.Matchup}>
          {game.gameTeams.map((gameTeam, i) => {
            return (
              <Fragment key={gameTeam.id}>
                <Link
                  className={cn(styles.Team, { [styles.LeftTeam]: i === 0, [styles.RightTeam]: i === 1 })}
                  href={gameTeam.isTbd ? undefined : gameTeam.team.webPath /* TODO nil webPath for TBD team? */}
                >
                  {gameTeam.scoreText && (
                    <div
                      className={cn(styles.Score, {
                        [styles.Winner]: gameTeam.result === GameTeamResultEnum.WIN,
                        [styles.Loser]: gameTeam.result === GameTeamResultEnum.LOSS
                      })}
                    >
                      {gameTeam.scoreText}
                    </div>
                  )}
                  <div className={styles.TeamInfo}>
                    <TeamImage className={styles.TeamImage} src={gameTeam.team.image} alt={gameTeam.team.name} />
                    <div>
                      <div className={styles.TeamName}>
                        {gameTeam.team.name} {gameTeam.team.mascot}
                      </div>
                      <div className={styles.TeamAbbrev}>{gameTeam.team.abbrev}</div>
                      <div className={styles.TeamSubText}>
                        {gameTeam.standing.overallRecord}
                        <span className={styles.RecordText}> Overall • {gameTeam.isHome ? 'Home' : 'Away'}</span>
                      </div>
                    </div>
                  </div>
                </Link>
                {i === 0 && (
                  <div className={styles.Status}>
                    {game.statusId === UPCOMING ? (
                      <>
                        <LocalizedDate date={game.date} format="MMM D" />
                        <br />
                        <LocalizedDate date={game.date} format="h:mm A" />
                      </>
                    ) : (
                      <>
                        {game.mediumStatusText}
                        {game.clockText && (
                          <>
                            <br />
                            {game.clockText}
                          </>
                        )}
                      </>
                    )}
                  </div>
                )}
              </Fragment>
            );
          })}
        </PageSection>
      </div>
      <NavBar>
        {game.contest?.bracket?.webPath && <NavButton href={game.contest.bracket.webPath}>Bracket</NavButton>}
        <NavButton href={game.webPath}>Details</NavButton>
        {game.webBoxscorePath && <NavButton href={game.webBoxscorePath}>Boxscore</NavButton>}
        {game.webScorebookCastPath && <NavButton href={game.webScorebookCastPath}>ScorebookCast</NavButton>}
        {game.webRecapPath && <NavButton href={game.webRecapPath}>Recap</NavButton>}
        {game.webPhotosPath && <NavButton href={game.webPhotosPath}>Photos</NavButton>}
        {game.statusId === UPCOMING && game.webPreviewPath && <NavButton href={game.webPreviewPath}>Preview</NavButton>}
        {game.statusId !== COMPLETED && (game.contest?.hometownTicketingUrl || game.contest?.gofanTicketingUrl) && (
          <NavButton href={game.contest.hometownTicketingUrl || game.contest.gofanTicketingUrl}>Tickets</NavButton>
        )}
        {game.contest?.nfhsNetworkUrl && (
          <NavButton href={setUtmReferrer(game.contest.nfhsNetworkUrl, 'game_details_subnav')}>Watch</NavButton>
        )}
      </NavBar>
    </>
  );
}
